import { registerMockRestEndpoints } from "@redotech/rpc-mock/mock-rest";
import {
  mockOnboardingData,
  mockTeamData,
  mockUserData,
} from "./mock-rest-data";

export function registerMerchantMockRestEndpoints(): void {
  registerMockRestEndpoints([
    { pattern: "/team", data: mockTeamData },
    { pattern: "/user", data: mockUserData },
    { pattern: "/onboarding", data: mockOnboardingData },
  ]);
}
